export default __webpack_public_path__ + "static/media/CV.e99715c0.pdf";